export interface ChainlinkFeedConfig {
  readonly tokenAddress: string;
  readonly feedAddress: `0x${ string }`;
  readonly pair: string;
}

// Maps a token on this explorer to the Chainlink price feed (on BNB Chain
// mainnet) that tracks the price of the real-world asset it represents.
const CHAINLINK_TOKEN_FEEDS: ReadonlyArray<ChainlinkFeedConfig> = [
  {
    tokenAddress: '0xd674ec6d370b5b6418679dcbc6a01aaedec93894', // WrapShiba
    feedAddress: '0xA615Be6cb0f3F36A641858dB6F30B9242d0ABeD8', // Chainlink SHIB/USD, BNB Chain mainnet
    pair: 'SHIB / USD',
  },
];

export function getChainlinkFeedForToken(address: string | undefined): ChainlinkFeedConfig | undefined {
  if (!address) {
    return undefined;
  }

  const normalized = address.toLowerCase();
  return CHAINLINK_TOKEN_FEEDS.find((feed) => feed.tokenAddress === normalized);
}

export default CHAINLINK_TOKEN_FEEDS;
